import { UUID } from '../utils/uuid';
import { getChatAuthHeaders } from './chat-auth-service';

export interface IFeedbackService {
  submitFeedback(args: {
    feedbackType: 'positive' | 'negative';
    sessionId: UUID;
    queryText: string;
    feedbackEntryUUID?: UUID;
    userFeedbackText?: string;
  }): Promise<UUID>;
}

export class FeedbackService implements IFeedbackService {
  async submitFeedback(args: {
    feedbackType: 'positive' | 'negative';
    sessionId: UUID;
    queryText: string;
    feedbackEntryUUID?: UUID;
    userFeedbackText?: string;
  }): Promise<UUID> {
    const authHeaders = await getChatAuthHeaders();
    const response = await fetch('/chat/feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...authHeaders,
      },
      body: JSON.stringify({
        feedback_type: args.feedbackType,
        session_id: args.sessionId,
        query_text: args.queryText,
        feedback_entry_uuid: args.feedbackEntryUUID,
        user_feedback_text: args.userFeedbackText,
      }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({ message: 'Unknown error during feedback submission' }));
      console.error('Feedback submission failed:', errorData);
      throw new Error(errorData.message);
    }
    const responseData = await response.json();
    return (responseData.feedbackEntryUUID ?? responseData.feedback_entry_uuid) as UUID;
  }
}
